// @ts-strict-ignore
import { IconName } from '@usealloy/component-library';

import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import { isActionAnImportedValue, isActionOfType } from 'flow/service/actions';
import type { NodeConnectorIntent } from 'flow/store/redux/types';
import type { NodeLineage, WorkflowNode } from 'flow/service/graph';


export function getConnectorIcon(connectorIntent: NodeConnectorIntent): IconName {
  if (connectorIntent === 'add') return IconName.Add;
  if (connectorIntent === 'link') return IconName.Link;

  return null;
}

export function getConnectorTooltipContent(
  connectorIntent: NodeConnectorIntent,
  focusedAction: Action,
  isDisabled: boolean,
): string {
  if (isDisabled) {
    if (isActionOfType(focusedAction, ActionType.INPUT)
      || isActionAnImportedValue(focusedAction)) {
      return `Cannot link ${isActionAnImportedValue(focusedAction) ? 'imported' : 'input'} nodes to other nodes.`;
    }

    return "Cannot link this node because it's a dependent\nof the selected node.";
  }
  if (connectorIntent === 'add') {
    return 'Add child node';
  }
  if (connectorIntent === 'link') {
    return 'Link to node';
  }

  return null;
}

/**
 * Determines whether or not a node can be connected to another one.
 * This check prevents building a cyclical graph by ensuring that no node is connected
 * to one of its dependents.
 * @param nodeLineage bundle of connections
 * @param nodeIdToConnectTo id of node to evaluate
 * @returns whether or not the connection is supported
 */
export function canLinkToNode(
  nodeLineage: NodeLineage,
  nodeIdToConnectTo: WorkflowNode['id'],
) {
  return !(
    nodeLineage?.directOutgoers?.has(nodeIdToConnectTo)
    || nodeLineage?.extendedOutgoers?.has(nodeIdToConnectTo)
  );
}
